module.exports = __webpack_public_path__ + "img/reliable-b-m-s.9df89d14.svg";